import { css, Theme } from '@emotion/react'
import { typography } from '@/styles'

export const styles = (theme: Theme) => ({
  label: {
    main: css`
      font-size: ${typography.h6};
      font-weight: bold;
      color: ${theme.colors.secondary.light};
    `,
  },
})
